<template>
  <div ref="inputbox">
    <div class="sr__input" :class="{'sr__input--invalid': !this.radioValid}">
      <b-form-radio-group
        v-model="value"
        class="sr__radio-group"
        :disabled="disable"
      >
        <b-form-radio
          v-for="(opt, oindex) in valueOptions"
          :key="oindex"
          :value="opt.value"
          class="sr__value"
        >
          {{opt.title}}
        </b-form-radio>
      </b-form-radio-group>

      <b-form-invalid-feedback :state="radioValid">
        {{ invalidRadioMsg }}
      </b-form-invalid-feedback>
    </div>

    <b-form-input
      class="sr__input"
      :class="{'sr__input--invalid': !this.textValid}"
      v-model="textValue"
      v-show="inputOpen"
      :disabled="disable"
    ></b-form-input>

    <b-form-invalid-feedback :state="textValid">
      {{invalidTextMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'InputOptionItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      defaultValue: 1,
      value: 0,
      textValue: '',
      valueOptions: [],
      radioValid: true,
      textValid: true,
      invalidTextMsg: '',
      invalidRadioMsg: '',
      switchToDefaultValue: false
    }
  },
  computed: {
    inputOpen () {
      return this.value === this.defaultValue
    }
  },
  methods: {
    checkValueIsValid (uiNotify = true) {
      if (this._isDestroyed) {
        this.radioValid = true
        this.invalidRadioMsg = ''

        this.textValid = true
        this.invalidTextMsg = ''
        return true
      }

      if ([this.defaultValue, 2].includes(this.value)) {
        this.radioValid = true
        this.invalidRadioMsg = ''

        if (this.value === this.defaultValue) {
          if (!this.textValue && !this.switchToDefaultValue) {
            if (!uiNotify) {
              return false
            }

            this.textValid = false
            this.invalidTextMsg = '欄位必填'
          } else {
            this.textValid = true
            this.invalidTextMsg = ''
            this.switchToDefaultValue = false
          }
        } else {
          this.textValid = true
          this.invalidTextMsg = ''
          this.switchToDefaultValue = false
        }
      } else {
        if (!uiNotify) {
          return false
        }

        this.radioValid = false
        this.invalidRadioMsg = '欄位必填'
      }

      return this.radioValid && this.textValid
    }
  },
  watch: {
    value () {
      this.switchToDefaultValue = this.field.value.value[0] !== this.defaultValue
      this.field.value.value[0] = this.value
      this.checkValueIsValid()
    },
    textValue () {
      this.field.value.text_value = this.textValue
      this.checkValueIsValid()
    }
  },
  created () {
    this.value = this.field.value.value[0] || this.value
    this.textValue = this.field.value.text_value || this.textValue
    this.valueOptions = this.field.value.value_options
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    this.$store.dispatch('pushValidateInfo', {
      id: this._uid,
      top: () => { return top },
      checkValueIsValid: this.checkValueIsValid
    })
  }
}
</script>
